import {
  AISH_NAME_COMBINED,
  AISH_NAME_LONG,
  AISH_NAME_SHORT,
  AISH_URL_MAIN,
  AISH_URL_APPLY,
  ADAP_NAME_COMBINED,
  ADAP_NAME_LONG,
  ADAP_NAME_SHORT,
  ADAP_URL_MAIN,
  CSSII_NAME_LONG,
  CSSII_NAME_SHORT,
  CSSII_URL_APPLY,
  CSSII_URL_MAIN,
  DIA_NAME_COMBINED,
  DIA_NAME_LONG,
  DIA_NAME_SHORT,
  DIA_URL_APPLY,
  DIA_URL_MAIN,
  CSSFB_NAME_SHORT,
  CSSFB_NAME_LONG,
  CSSFB_NAME_COMBINED,
  CSSFB_URL_MAIN,
  CSSFB_URL_APPLY,
  CSSFSCDI_NAME_SHORT,
  CSSFSCDI_NAME_LONG,
  CSSFSCDI_NAME_COMBINED,
  CSSFSCDI_URL_APPLY,
  CSSFSCDI_URL_MAIN,
} from './program-names';

export interface ProgramLookup {
  abbreviation?: string;
  fullName?: string;
  combinedName?: string;
  aOrAn?: string; //used for 'an AISH application' or 'a DIA application'
  urlMain?: string;
  urlApply?: string;
}

export type ProgramKey = 'aish' | 'adap' | 'incomeSupport' | 'dia' | 'fb' | 'fscd'; //ensure these are the only keys they can use
export const ProgramList: Record<ProgramKey, ProgramLookup> = {
  aish: {
    abbreviation: AISH_NAME_SHORT,
    fullName: AISH_NAME_LONG,
    combinedName: AISH_NAME_COMBINED,
    aOrAn: 'an',
    urlMain: AISH_URL_MAIN,
    urlApply: AISH_URL_APPLY,
  },
  adap: {
    abbreviation: ADAP_NAME_SHORT,
    fullName: ADAP_NAME_LONG,
    combinedName: ADAP_NAME_COMBINED,
    aOrAn: 'an',
    urlMain: ADAP_URL_MAIN,
  },
  incomeSupport: {
    abbreviation: CSSII_NAME_SHORT,
    fullName: CSSII_NAME_LONG,
    aOrAn: 'an',
    urlMain: CSSII_URL_MAIN,
    urlApply: CSSII_URL_APPLY,
  },
  dia: {
    abbreviation: DIA_NAME_SHORT,
    fullName: DIA_NAME_LONG,
    combinedName: DIA_NAME_COMBINED,
    aOrAn: 'a',
    urlApply: DIA_URL_APPLY,
    urlMain: DIA_URL_MAIN,
  },
  fb: {
    abbreviation: CSSFB_NAME_SHORT,
    fullName: CSSFB_NAME_LONG,
    combinedName: CSSFB_NAME_COMBINED,
    aOrAn: 'a',
    urlApply: CSSFB_URL_APPLY,
    urlMain: CSSFB_URL_MAIN,
  },
  fscd: {
    abbreviation: CSSFSCDI_NAME_SHORT,
    fullName: CSSFSCDI_NAME_LONG,
    combinedName: CSSFSCDI_NAME_COMBINED,
    aOrAn: 'a',
    urlApply: CSSFSCDI_URL_APPLY,
    urlMain: CSSFSCDI_URL_MAIN,
  }
};
